import React from "react";
import {
  AuBankIcon,
  AuBankLogo,
  AuBankSmallIcon,
  BusinessInformationIcon,
  BusinessInformationRedIcon,
  BusinessSecurityIcon,
  BusinessSecurityRedIcon,
  CreateAccountIcon,
  PasswordSettingIcon,
  PasswordSettingRedIcon,
  PersonalInformationIcon,
  PersonalInformationRedIcon,
  ProjExelLogo,
} from "../../assets/images";

import "./SignUpCard.scss";
type AppProps = {
  currentStep: number;
  isOtpVerify: boolean;
  activeStep: number;
};

const LeftSideSignUpInfo = ({
  currentStep,
  isOtpVerify,
  activeStep,
}: AppProps) => {
  const {pathname} = window.location;
  const steps = [
    {
      icon: CreateAccountIcon,
      redIcon: CreateAccountIcon,
      title: "Create Account",
      subtitle: "Enter OTP to verify account",
    },
    {
      icon: AuBankSmallIcon,
      redIcon: AuBankSmallIcon,
      title: "Unlock AU Benefits",
      subtitle: "Confirm account to unlock plans",
    },
    {
      icon: BusinessSecurityIcon,
      redIcon: BusinessSecurityRedIcon,
      title: "Business Details & Security",
      subtitle: "Final step to complete your account.",
    },
  ]

  const withoutAuSteps = [
     {
      icon: CreateAccountIcon,
      redIcon: CreateAccountIcon,
      title: "Create Account",
      subtitle: "Enter OTP to verify account",
    },
    // {
    //   icon: PersonalInformationIcon,
    //   redIcon: PersonalInformationRedIcon,
    //   title: "Personal Information",
    //   subtitle: "Enter your details to get started.",
    // },
    {
       icon: BusinessInformationIcon,
      redIcon: BusinessInformationRedIcon,
      title: "Business Information",
      subtitle: "Set up your business profile.",
    },
    {
      icon: PasswordSettingIcon,
      redIcon: PasswordSettingRedIcon,
      title: "Set Password",
      subtitle: "Enter email and set password.",
      },
  ];
  const stepsToDisplay = pathname==="/signup" ? withoutAuSteps :steps ;
  return (
    <div className="left-side-info-main-conatiner">
      <div>
        <div style={{ display: 'flex', gap: '10%' }}>
          <div className="company-logo-container">
            <img src={ProjExelLogo} alt="Finac Logo" style={{ height: "50px" }} />
          </div>
         {pathname!=="/signup"? <div className="company-logo-container">
            <img src={AuBankLogo} alt="Finac Logo" style={{ height: "50px" }} />
          </div>:""}
        </div>

        <div style={{ marginBottom: "30px" }}>
          {stepsToDisplay?.map((step, index) => (
            <div key={index} className="main-inner-conatiner">
              <div className="icon-container">
                <div
                  className={`left-pannel-imageBox ${activeStep === index ? "active" : ""
                    }`}
                >
                  <img
                    src={
                      activeStep === index || activeStep > index
                        ? step?.redIcon
                        : step?.icon
                    }
                    alt={`${step?.title} Icon`}
                    // className="left-pannel-image"
                    className={`left-pannel-image ${step?.title === "Unlock AU Benefits" ? 'left-pannel-au-image' : ''}`}
                  />
                </div>
              </div>
              <div>
                <h3
                  // className="left-panel-title"
                  // className={`left-panel-title ${
                  //   activeStep === index ? "active" : ""
                  // }`}
                  className={`left-panel-title ${activeStep === index ? "active" : ""} ${step?.title === "Unlock AU Benefits" ? "left-panel-au-title" : ""
                    }`}
                >{step?.title}</h3>
                <p className="left-panel-subTitle">{step?.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="copyright-container">
        <p className="copyright">
          &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
        </p>
      </div>
    </div>
  );
};

export default LeftSideSignUpInfo;
